import { render, staticRenderFns } from "./ManagementBalanceBtnDropdown.vue?vue&type=template&id=ed175950"
import script from "./ManagementBalanceBtnDropdown.vue?vue&type=script&lang=js"
export * from "./ManagementBalanceBtnDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports